import React from 'react';
import createSvgIcon from '../createNewIcon.js';
const ChevronDown = createSvgIcon(React.createElement("polygon", { points: "12,16.9 3.5,8.5 4.9,7.1 12,14.1 19.1,7.1 20.5,8.5" }), 'ChevronDown');
export default ChevronDown;
